import { TranslationKeys } from "./en";

export const es: TranslationKeys = {
  // Welcome Page
  welcome: {
    title: "Intercomunicador con Código QR Inteligente",
    subtitle: "Sistema de Acceso Seguro al Edificio",
    welcomeTitle: "Bienvenido",
    description:
      "Por favor, toque el botón a continuación para comenzar a usar el sistema de intercomunicador",
    tapToStart: "Toque para Comenzar",
    footerText: "Toque la pantalla para comenzar",
  },

  // Home Page
  home: {
    welcome: "Bienvenido",
    verifyingQR: "Verificando código QR...",
    verified: "Código QR verificado ✓ sesión establecida",
    error: "Error",
  },

  // Directory
  directory: {
    title: "Directorio",
    searchPlaceholder: "Buscar habitaciones...",
    noRooms: "No se encontraron habitaciones",
    floor: "Piso",
    calling: "Llamando...",
    roomsCount: "{count} de {total} habitaciones",
  },

  // Number Pad
  numberPad: {
    deliveryTitle: "PIN de entrega",
    roomTitle: "PIN de habitación",
    selectDeliveryService: "Seleccionar servicio de entrega",
    selectRoom: "Seleccionar habitación",
    placeholder: "Por favor seleccione...",
    clear: "Limpiar",
    confirm: "Confirmar",
    errorMinDigits: "Por favor ingrese al menos 4 dígitos",
    hintDelivery: "Por favor, ingrese el PIN de entrega.",
    hintRoom: "Por favor, ingrese el PIN de la habitación.",
    hintMinMax: "Entre 4 y 6 dígitos.",
  },

  // Guest Pass
  guestPass: {
    title: "Pase de invitado",
    description:
      "Por favor, ingrese su PIN de invitado para acceder al edificio",
    clear: "Limpiar",
    confirm: "Confirmar",
    errorMinDigits: "Por favor ingrese al menos 4 dígitos",
    hint1: "Ingrese el PIN de invitado que le proporcionaron.",
    hint2: "Entre 4 y 8 dígitos.",
    backToHome: "Volver al Inicio",
    welcomeMessage: "¡Bienvenido {name}! La puerta se está abriendo...",
    doorFailedToOpen:
      "PIN verificado pero la puerta no se pudo abrir. Por favor contacte a la administración.",
    sessionMissing:
      "Falta el token de sesión. Por favor actualice la página o escanee el código QR nuevamente.",
    invalidPin: "PIN de invitado inválido. Por favor intente nuevamente.",
    sessionExpired:
      "Sesión expirada. Por favor actualice la página o escanee el código QR nuevamente.",
    errorOccurred: "Ocurrió un error. Por favor intente nuevamente.",
  },

  // Visitor Check-In
  visitorCheckIn: {
    title: "Registro de Visitantes",
    back: "Atrás",
    firstName: "Nombre",
    lastName: "Apellido",
    company: "Empresa",
    whoToVisit: "A Quién Visitar",
    firstNamePlaceholder: "Ingrese el nombre del visitante",
    lastNamePlaceholder: "Ingrese el apellido del visitante",
    companyPlaceholder: "Ingrese la empresa del visitante",
    whoToVisitPlaceholder: "¿A quién está visitando el visitante?",
    firstNameRequired: "El nombre es requerido",
    lastNameRequired: "El apellido es requerido",
    companyRequired: "La empresa es requerida",
    whoToVisitRequired: "El campo de quién visita es requerido",
    cancel: "Cancelar",
    checkIn: "Registrar",
    checkingIn: "Registrando...",
    successMessage: "Registro de visitante exitoso para {firstName} {lastName}",
    errorMessage: "Error durante el registro. Por favor intente nuevamente.",
  },

  // Video Call Page
  videoCall: {
    callingManager: "Llamando al Administrador",
    callingResident: "Llamando a {name}",
    room: "Habitación {room}",
    videoCall: "Videollamada",
    endCall: "Finalizar Llamada",
    callError: "Error de Llamada",
    invalidCallData: "Datos de llamada inválidos",
    goBack: "Volver",
    callEnded: "Llamada terminada",
    otherPartyHungUp: "La otra parte ha colgado",
    ok: "OK",
    noAnswer: "Nadie contestó",
    noAnswerMessage:
      "Parece que nadie contestó la llamada en {seconds} segundos. Por favor intente más tarde.",
    autoClosing: "Cerrando automáticamente en {count} segundos...",
    mute: "Silenciar",
    unmute: "Activar Sonido",
    turnOffVideo: "Desactivar video",
    turnOnVideo: "Activar video",
  },

  // Messages
  messages: {
    error: "Error",
    success: "¡Éxito!",
    sessionExpired: "Sesión Expirada",
    sessionExpiredMessage:
      "Su sesión ha expirado después de 5 minutos. Por favor actualice la página o escanee el código QR nuevamente.",
    sessionExpiredShort:
      "Su sesión ha expirado. Por favor actualice la página o escanee el código QR nuevamente.",
    sessionExpiredContinue:
      "Su sesión ha expirado. Por favor actualice la página o escanee el código QR nuevamente para continuar.",
    pleaseVerifyQR: "Por favor verifique el código QR primero",
    pleaseSelectDelivery: "Por favor seleccione un servicio de entrega",
    pleaseSelectRoom: "Por favor seleccione una habitación",
    deliveryPinVerified:
      "PIN de entrega verificado y la puerta se está abriendo para {name}",
    roomPinVerified:
      "PIN de habitación verificado y la puerta se está abriendo para la Habitación {name}",
    doorFailedToOpen: "Fallo al Abrir la Puerta",
    doorFailedMessage:
      "PIN verificado pero la puerta no se pudo abrir. Por favor contacte a la administración.",
    pinVerificationFailed: "Fallo en la Verificación del PIN",
    invalidPin: "Código PIN inválido",
    pinVerificationError: "Error de verificación del PIN",
    callRoomFailed: "Fallo en la Llamada a la Habitación",
    callRoomError: "Error de Llamada a la Habitación",
    callManagerFailed: "Fallo en la Llamada al Administrador",
    callManagerError: "Error de Llamada al Administrador",
  },

  // Button Labels
  buttons: {
    directory: "Directorio",
    delivery: "PIN de entrega",
    doorPin: "PIN de puerta",
    guestPass: "Pase de invitado",
    callReception: "Llamar a recepción",
    visitorCheckIn: "Registro de Visitantes",
  },

  // Common
  common: {
    loading: "Cargando...",
    close: "Cerrar",
    cancel: "Cancelar",
    confirm: "Confirmar",
    back: "Atrás",
    required: "*",
  },

  // Language Switcher
  language: {
    select: "Idioma",
    english: "English",
    french: "Français",
    spanish: "Español",
  },
};
